import Popper from 'popper.js';

export default {
  name: 'MDropdownMenu',
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    open() {
      this.isOpen = !this.isOpen;
      // eslint-disable-next-line no-new
      new Popper(this.$refs.button, this.$refs.menu, {
        placement: 'bottom',
      });
    },
    close() {
      if (!this.isOpen) {
        return;
      }
      this.isOpen = false;
    },
    handleSelect(item) {
      this.$emit('action', item);
      this.close();
    },
  },
};
